export interface ISerologyBloodDraw {
    id: number,
    donorAlias: string,
    recipientAlias: string,
    donorCenterId: number,
    donorCenterAlias: string,
    scheduledDonationDate: string,
    bloodDrawDate: string,
    resultsDate: string,
    hasResults: boolean
}
